export class CheckHelper {
  private checkNum = 0;
  private readonly MAXCHECKNUM = 1000000;
  private checkFuncMap = new Map();
  private timeCount = 0;

  /** 重置检查器计数 */
  clear(): void {
    this.checkNum = 0;
  }

  /** 更新检查器计数 */
  updateChecker(): void {
    this.checkNum = (this.checkNum + 1) % (this.MAXCHECKNUM + 1);
  }

  /** 获取当前检查器计数 */
  getChecker(): number {
    return this.checkNum;
  }

  /** 获取带时间戳的检查器值 */
  getNormalChecker(): string {
    return `${this.checkNum}_${this._getNowTimeStr()}`;
  }

  /**
   * 获取格式化的当前时间字符串
   *
   * @private
   */
  private _getNowTimeStr(): string {
    const d = new Date();
    return `${(d.getMonth() + 1).toString().padStart(2, "0")}-${d.getDate()} ${d.getHours()}:${d
      .getMinutes()
      .toString()
      .padStart(2, "0")}:${d.getSeconds().toString().padStart(2, "0")}`;
  }

  /** 注册检查器 */
  registerFuncChecker(key: string, func: string, timeout: number) {
    this.checkFuncMap.set(key, { func: func, timeout: timeout });
  }

  /** 清除所有函数检查器 */
  clearAllFuncChecker() {
    this.checkFuncMap.clear();
  }

  /**
   * 移除指定键的函数检查器
   *
   * @param key - 要移除的检查器的键名
   */
  removeFuncChecker(key: string) {
    if (this.checkFuncMap.has(key)) {
      this.checkFuncMap.delete(key);
    }
  }

  /**
   * 获取指定键的函数检查器
   *
   * @param key - 要获取的检查器的键名
   * @returns 返回对应的检查器函数，如果不存在则返回 undefined
   */
  getFuncChecker(key: string) {
    return this.checkFuncMap.get(key);
  }

  /**
   * 检查函数超时状态 每0.5秒检查一次所有检查器的超时状态
   *
   * @param dt - 时间增量（秒）
   * @returns 如果有任何检查器超时，返回 true；否则返回 false
   */
  checkFuncTimeout(dt: number) {
    this.timeCount += dt;
    let isFuncTimeout = false;
    if (this.timeCount >= 0.5) {
      // 0.5s更新一次, 减少遍历次数
      this.checkFuncMap.forEach((callback, key) => {
        if (callback && callback.timeout > 0) {
          callback.timeout -= this.timeCount;
          if (callback.timeout <= 0) {
            this.removeFuncChecker(key);
            isFuncTimeout = true;
          }
        }
      });
      this.timeCount = 0;
    }
    return isFuncTimeout;
  }
}
